module.exports = __webpack_public_path__ + "img/join_2.3c528601.jpg";